//photographs.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Photographcard from '../components/Photographs/Photographcard';
import { getMethod } from '../services/apiService';
import LoadingSpinner from '../utility/LoadingSpinner';

function Photography() {
  const [photographData, setPhotographData] = useState([]);
  const [latestEntry, setLatestEntry] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    fetchData();
  }, []);

  //Display PhotographList - GET
  const fetchData = async () => {
    const response = await getMethod('categories');
    if (response.status && Array.isArray(response.category)) {
      const data = response.category.map(item => ({
        id: item.id,
        title: item.name,
      }));
      setPhotographData(data);
    } else {
      console.error("Error fetching paintings", response);
      setPhotographData([]);
    }
  };

  //Display welcome content - GET
  useEffect(() => {
    const getWelcome = async () => {
      try {
        const response = await getMethod('welcome');
        if (!response.error && response.data) {
          const data = response.data;
          if (Array.isArray(data) && data.length > 0) {
            const lastItem = data[data.length - 1];
            setLatestEntry(lastItem);
            localStorage.setItem('welcomeContent', lastItem);
          } else if (data.title && data.description) {
            setLatestEntry(data);
            localStorage.setItem('welcomeContent', data);
          }
        } else {
          const storedContent = localStorage.getItem('welcomeContent');
          if (storedContent) {
            setLatestEntry(storedContent);
          }
        }
      } catch (error) {
        console.error('Error fetching welcome content:', error);
        const storedContent = localStorage.getItem('welcomeContent');
        if (storedContent) {
          setLatestEntry(storedContent);
        }
      }
    };

    getWelcome();
  }, []);

  if (!latestEntry) return <LoadingSpinner />;

    const handleClick = () => {
    navigate(`/`);  // Navigate with query param & path, query, key=value pair
  };

  return (
    <div className="page-container"> 
      <h2 className="poems__title_photo"><span><a href="#" onClick={(e) => handleClick()}><img src={require('../assets/images/back.png')} style={{ width: 25 }} /></a></span>Photographs</h2>

      <div className="photograph-list" >
        {Array.isArray(photographData) &&
          photographData.map(photographs => (
            <Photographcard
              key={photographs.id}
              title={photographs.title}
              id={photographs.id} />
          ))}
      </div>

      <section className="photography-section" >
        {/* {latestEntry.photography_description} */}
        <div
          dangerouslySetInnerHTML={{ __html: latestEntry.photography_description }}
        />
      </section>

    </div>
  );
}
export default Photography;